import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { EquityFieldKey } from 'types';

const { persistAtom } = recoilPersist();

export const optionsCalculatorTickerCurrentFieldsState = atom<EquityFieldKey[]>(
  {
    key: 'optionsCalculator-tickerCurrentFieldsState',
    default: [],
    effects_UNSTABLE: [persistAtom],
  },
);
